import { Routing } from './../routing/app.routing';
import { PeticionesService } from './../services/peticiones.service';
import { CajasTextos, BtnLogin, Etiquetas, LoginData } from './../models/login.model';
import { Component } from '@angular/core';
import { Router } from '@angular/router';



@Component({
  selector: 'app-login',
  templateUrl: './../views/login.component.html',
  styleUrls: ['./../css/login.component.css'],
  providers: [PeticionesService]

})


export class LoginComponent {
    public CajasTextos:CajasTextos;
    public botonLogin: BtnLogin;
    public Etiquetas: Etiquetas;
    public credenciales: LoginData;
    public validaciones: any;
    public validacionesOK: boolean;
    public logeado= false;

  constructor(
    private _peticionesServices : PeticionesService,
    private _router :Router
  ){

    this.CajasTextos = new CajasTextos("nombre usuario", "password");
    this.botonLogin = new BtnLogin("Iniciar sesión");
    this.Etiquetas = new Etiquetas("Iniciar Sesión","Ingrese Nombre de Usuario", "Ingrese Su Contraseña");
    this.credenciales = new LoginData("","");
    this.validacionesOK = false;


  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.validaciones = this._peticionesServices.getValida();



  }

  onSubmit(){
    //prueba de manera local con usuario en duro se debe cambiar logica después
    var user= this.credenciales.usuario;
    var pass = this.credenciales.pass;
    var validUser1 = this.validaciones.usuario1;
    var validUser2 = this.validaciones.usuario2;
    var validUser3 = this.validaciones.usuario3;
    var validUser4 = this.validaciones.usuario4;
    var validPass = this.validaciones.pass;

    if((user==validUser1 ||user== validUser2 ||user== validUser3 || user==validUser4) && (pass == validPass)){
      this.validacionesOK =true;
    }else{
      this.validacionesOK = false; 
    };
    if (this.validacionesOK) {
      console.log("paso"); 
      this.logeado=true;
      if(this.logeado=true){
        localStorage.setItem('usuario logeado','sesion iniciada');
        console.log(localStorage);
        alert('Bienvenido a Gestor de Pacientes');
      }
      this._router.navigate(['home']);
    } else {
      console.log("no paso");
      alert('el usuario o password son incorrectos');
      this._router.navigate(['login']);
    }
    return this.validacionesOK;
  }

}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/